import { memberService, publicService, uploadFileService, surveyService, adminService, kokwatchService, agraService } from '../services';

const apiModule = {
  namespaced: true,
  state: {
    memberService: memberService,
    publicService: publicService,
    uploadFileService: uploadFileService,
    surveyService: surveyService,
    adminService: adminService,
    kokwatchService: kokwatchService,
    agraService: agraService
  },
  actions: {
    async apiCall ({ commit }, data) {
      const result = await this.state.api[data.svName][data.fnName](data.param);
      return result;
    }
  }
};

export default apiModule;
